<script>
  import { createEventDispatcher, getContext } from 'svelte'

  import Modal from '@/components/ui/Modal/Modal.svelte'
  import Tabs from '@/components/ui/tabs/Tabs.svelte'
  import Flex from '@/components/ui/flex/Flex.svelte'

  export let tabs = []

  export let isOpen = false

  export let modalTitle = null

  export let onClose = null
  export let onSave = null

  export let activeTab = null

  export let pluginRef = null

  export let instance = null

  const platform = getContext('platform')

  const dispatch = createEventDispatcher()

  const pluginPreviewFields = platform.api.core.store('pluginPreviewFields')

  $: if (activeTab) {
    dispatch('tabChange', activeTab)
  }
</script>

<Modal
  bind:isOpen={isOpen}
  onClose={onClose}
  modalTitle={modalTitle}
  draggable={true}
  width={'1400'}
  onSave={onSave}
  isDismissable={false}
>
  <Flex direction="column" gap="xl" width="650px">
    {#if tabs.length}
      <Tabs {tabs} bind:activeTab={activeTab} />
    {/if}
    <div class="cms-tw jolojo-edit-modal">
      <slot />
    </div>
  </Flex>

  <div
    slot="aside-right"
    class="preview-container cms-template"
    style:padding={instance?.editPlugin?.withPreview ? 'var(--jolojo-ui-md-padding)' : '0'}
    style:border-left={instance?.editPlugin?.withPreview ? '1px solid var(--jolojo-ui-grey-1)' : '0'}
  >
    {#if instance?.editPlugin?.withPreview}
      <div class="preview">
        {#if pluginRef}
          {@const module = platform.components[pluginRef]}
          <div class="preview-wrapper">
            <svelte:component
              this={module.default}
              fields={$pluginPreviewFields}
            />
          </div>
        {/if}
      </div>
    {/if}
  </div>
</Modal>

<style lang="scss">.preview-container {
  height: 100%;
  display: grid;
  place-items: center;
}
@media (max-width: 1300px) {
  .preview-container {
    display: none;
    padding: 0;
  }
}

.preview {
  width: 500px;
}

.jolojo-edit-modal {
  height: 600px;
  width: 100%;
  max-height: calc(80vh - 180px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 5px;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>